import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { all_routes } from "../../../../../router/all_routes";
import { useUserPermissions } from "../../../../../UserPermissionsContext";

type Permission = { id: number; name: string };

type Admin = {
  // permissions: Array<number>;
  name: string | null;
  // id: number;
  is_callback_time?: boolean | null;
};

type Disposition = {
  student_disposition_id: number;
  disposition_name: string;
};

type TicketType = {
  ticket_type_id: number;
  ticket_type: string;
};

interface ErrorMessages {
  name?: string[];
}

const PrisamAddCategory = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const [dispositions, setDispositions] = useState<Disposition[]>([]);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDisposition, setSelectedDisposition] =
    useState<Disposition | null>(null);
  const [typeOfTicket, setTypeOfTicket] = useState<TicketType[]>([]);
  const [selectedTypeOfTicket, setSelectedTypeOfTicket] =
    useState<TicketType | null>(null);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    // id: 0,
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [dispositionsData, typeOfTicketData] = await Promise.all([
  //       fetchDispositions(),
  //       fetchTypeOfTicket(),
  //     ]);
  //     setDispositions(dispositionsData);
  //     setTypeOfTicket(typeOfTicketData);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!checkPermission("add_schoolticketcategory", "schoolticketcategory")) {
      navigate(routes.crmLandingPage);
    } else {
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/school_leads/school_ticket_category/`;
    const response = await fetch(url, requestOptions);
    const errorData = await response.json();

    if (!response.ok) {
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      setErrorMessage(errorData);
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.prisamCategories);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value === "true" });
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Category</h3>
                <ul className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li> */}
                  <li className="breadcrumb-item">
                    <Link to={routes.prisamCategories}>Categories</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Category</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <div className="modal-body light-violet-bg d-flex">
                      {/* <div
                        className="mb-3 me-3"
                        style={{ width: "35%"}}
                      >
                        <label className="form-label">Disposition</label>
                        <CommonSelect
                          className="select"
                          options={dispositionOptions}
                          onChange={handleDispositionChange}
                        />
                      </div> */}
                      {/* <div
                        className="mb-3"
                        style={{ flex: "1 1 50%", maxWidth: "300px" }}
                      >
                        <label className="form-label">Ticket Type</label>
                        <CommonSelect
                          className="select"
                          options={ticketTypeOptions}
                          onChange={handleTicketTypeChange}
                        />
                      </div> */}
                    </div>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Category Name</label>
                      <input
                        type="text"
                        className={`form-control ${errorMessage.name ? "is-invalid" : ""
                          }`}
                        name="name"
                        placeholder="Category Name"
                        onChange={handleInputChange}
                        value={newAdmin.name || ""}
                        required
                      />
                      {errorMessage.name && (
                        <div className="invalid-feedback">
                          {errorMessage.name[0]}
                        </div>
                      )}
                    </div>
                    <div
                      className="radio-group-item"
                      style={{
                        flex: 1,
                        marginBottom: "9px",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <label className="form-label">Is Call Back Time Needed</label>
                      <div>
                        <input
                          type="radio"
                          id="is_superuser_yes"
                          name="is_callback_time"
                          value="true"
                          checked={newAdmin?.is_callback_time === true}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="is_superuser_yes"
                          style={{
                            marginLeft: "5px",
                            marginRight: "15px",
                            cursor: "pointer",
                          }}
                        >
                          Yes
                        </label>
                        <input
                          type="radio"
                          id="is_superuser_no"
                          name="is_callback_time"
                          value="false"
                          checked={newAdmin?.is_callback_time === false}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="is_superuser_no"
                          style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                        >
                          No
                        </label>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.prisamCategories}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrisamAddCategory;
